// *** AUTOMATICALLY GENERATED FILE FOR WINDOWS *** //
export const environment = {
  isProduction: false,
  firebaseConfig: {
    apiKey: "AIzaSyAwRPa0opECp6E5N0jOwusx9PPrsNsTrhM",
    authDomain: "ravcredit-2b079.firebaseapp.com",
    projectId: "ravcredit-2b079",
    storageBucket: "ravcredit-2b079.appspot.com",
    appId: "1:1059462239029:web:ffb8d28ed157f80d77327c"
  }
};